"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTINE_SLOT_ORDER = exports.SLOT_METADATA = exports.validRoutineSlots = exports.RoutineSlots = void 0;
exports.isValidRoutineSlot = isValidRoutineSlot;
const api_1 = require("./api");
// ============================================================================
// Routine Slot Utilities
// ============================================================================
/**
 * Type-safe routine slot constants object
 * Provides compile-time safety when referencing routine slots
 *
 * @example
 * ```ts
 * import { RoutineSlots } from '@see-stella/types'
 * const slot = RoutineSlots.CLEANSER // 'cleanser'
 * ```
 */
exports.RoutineSlots = {
    MAKEUP_REMOVER: 'makeup_remover',
    CLEANSER: 'cleanser',
    EXFOLIANT: 'exfoliant',
    TONER: 'toner',
    SERUM: 'serum',
    SPOT_TREATMENT: 'spot_treatment',
    FACE_MASK: 'face_mask',
    EYE_TREATMENT: 'eye_treatment',
    LIP_TREATMENT: 'lip_treatment',
    MOISTURIZER: 'moisturizer',
    SUNSCREEN: 'sunscreen',
    AFTERSUN: 'aftersun',
    NECK_TREATMENT: 'neck_treatment',
    EXCLUDE: 'EXCLUDE',
    UNKNOWN: 'UNKNOWN',
};
/**
 * Set of valid routine slots for runtime validation
 */
exports.validRoutineSlots = new Set(api_1.routineSlotEnum);
/**
 * Type guard to check if a string is a valid RoutineSlot
 *
 * @example
 * ```ts
 * const slot = product.routineSlot
 * if (isValidRoutineSlot(slot)) {
 *   // slot is now typed as RoutineSlot
 * }
 * ```
 */
function isValidRoutineSlot(value) {
    return value != null && exports.validRoutineSlots.has(value);
}
// ============================================================================
// Routine Slot Metadata
// ============================================================================
exports.SLOT_METADATA = {
    makeup_remover: {
        name: 'Makeup Remover',
        order: 1,
        description: 'Oil cleansers, balms, makeup removers',
    },
    cleanser: {
        name: 'Cleanser',
        order: 2,
        description: 'Face washes, foaming cleansers, gel cleansers',
    },
    exfoliant: {
        name: 'Exfoliant',
        order: 3,
        description: 'AHA/BHA products, scrubs, peels',
    },
    toner: {
        name: 'Toner',
        order: 4,
        description: 'Toners, hydrating mists, essences (watery)',
    },
    serum: {
        name: 'Serum',
        order: 5,
        description: 'Serums, essences (concentrated), ampoules, treatments',
    },
    spot_treatment: {
        name: 'Spot Treatment',
        order: 6,
        description: 'Acne treatments, blemish gels',
    },
    face_mask: {
        name: 'Face Mask',
        order: 7,
        description: 'Sheet masks, clay masks, overnight masks',
    },
    eye_treatment: {
        name: 'Eye Treatment',
        order: 8,
        description: 'Eye creams, eye serums',
    },
    lip_treatment: {
        name: 'Lip Treatment',
        order: 9,
        description: 'Lip balms, lip masks',
    },
    moisturizer: {
        name: 'Moisturizer',
        order: 10,
        description: 'Face creams, lotions, gels',
    },
    sunscreen: {
        name: 'Sunscreen',
        order: 11,
        description: 'SPF products, sun protection',
    },
    aftersun: {
        name: 'Aftersun',
        order: 12,
        description: 'Aftersun treatments',
    },
    neck_treatment: {
        name: 'Neck Treatment',
        order: 13,
        description: 'Neck creams',
    },
    EXCLUDE: {
        name: 'Exclude',
        order: 14,
        description: 'Exclude from routine',
    },
    UNKNOWN: {
        name: 'Unknown',
        order: 15,
        description: 'Unknown routine slot',
    },
};
/**
 * Standard order for displaying routine slots
 * Sorted by the order field in SLOT_METADATA
 */
exports.ROUTINE_SLOT_ORDER = Object.entries(exports.SLOT_METADATA)
    .sort(([, a], [, b]) => a.order - b.order)
    .map(([slot]) => slot).filter((slot) => slot !== 'EXCLUDE'); // Exclude EXCLUDE from display order
//# sourceMappingURL=routine.js.map